export const DOWNLOAD_MANAGER_DEFAULT_ERROR_NAME = 0;
export const DOWNLOAD_MANAGER_CANCEL_ERROR_NAME = 1;
